import React from 'react';

import { ModalLayout } from 'layouts/ModalLayout/ModalLayout';
import styles from './WarningModal.module.scss';

// A confirm-only dialog: it renders an "Ok" button and nothing else. It used to
// also carry an unreachable handleAdd that posted an article shaped
// { publishingDate, content } — a shape /articles/create does not read, so it
// would have published a blank article had anything ever called it.
export const WarningModal = ({ setWarningModal, height, onConfirm }: any) => {
  const handleClose = () => {
    setWarningModal(false);
  };

  return (
    <ModalLayout
      height={height}
      handleClose={handleClose}
      title={'Updates will not be saved'}
    >
      <button type="button" className={styles.buttonDark} onClick={onConfirm}>
        Ok
      </button>
    </ModalLayout>
  );
};
